'use client'

import {
  type ClientJourneyOutcome,
  startClientJourney,
} from '@brew/observability/browser'

/** Session wall time includes listening; first text finishes only when the editor displays text. */
export function beginDictationObservation() {
  const begin = (phase: 'ready' | 'first_text' | 'session') =>
    startClientJourney(`client.dictation.${phase}`, {
      timeoutMs: phase === 'session' ? 600_000 : 60_000,
      tags: {
        domain: 'chat',
        surface: 'dictation',
        phase,
        transport: 'browser',
      },
    })
  const ready = begin('ready')
  const firstText = begin('first_text')
  const session = begin('session')
  return {
    ready: () => ready.finish('success'),
    firstText: () => firstText.finish('success'),
    finish(outcome: ClientJourneyOutcome) {
      ready.finish(outcome === 'success' ? 'skipped' : outcome)
      firstText.finish(outcome === 'success' ? 'skipped' : outcome)
      session.finish(outcome)
    },
  }
}
